<template>
  <div class="list">
    <notifications></notifications>
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
            ></head-menu-filter>

            <div class="row mb-2">
              <div class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.gebaeude"
                        :options="gebaeude"
                        label="bezeichnung"
                        :reduce="(g) => g.id"
                        :placeholder="$t('global.hotel')"
                      ></v-select>
                      <label>{{ $t("global.hotel") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input v-model="filters.lehrgang" class="form-control input" type="text" placeholder=" " />
                      <label>{{ $t("global.educationcourse") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input v-model="filters.veranstaltung" class="form-control input" type="text" placeholder=" " />
                      <label>{{ $t("global.shorteventormodule") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group" id="number-of-records">
                      <input v-model="filters.count" class="form-control input" type="text" placeholder=" " />
                      <label>{{ $t("global.numberofrecords") }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.hotelquotas')"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row d-flex justify-content-between">
                  <div class="ml-4">
                    <router-link
                      v-if="zimmerRecht('create')"
                      class="btn btn-success"
                      :to="{ name: 'hotelkontingent', params: { anzeige: 0 } }"
                    >
                      <font-awesome-icon icon="fa-regular fa-plus" />
                      {{ $t("global.new") }}
                    </router-link>
                  </div>
                  <div class="mr-4 float-right">
                    <button class="btn btn-danger" @click="oeffneLoeschenModal" v-if="zimmerRecht('delete')">
                      <font-awesome-icon icon="fa-duotone fa-trash" class="mr-2" />{{ $t("global.delete") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste">
              <div class="w-100-p">
                <b-table
                  ref="selectableTable"
                  small
                  tbody-tr-class="item"
                  :items="listData"
                  :fields="fields"
                  sort-icon-left
                  fixed
                  selectable
                  select-mode="range"
                  @row-dblclicked="details"
                  thead-tr-class="pointer"
                >
                  <template v-slot:head(selected)="header">
                    <b-form-checkbox
                      ref="headerCheckbox"
                      v-model="header.selected"
                      @input="selectAllRows(header)"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(selected)="row">
                    <b-form-checkbox v-model="row.item.selected" @input="onRowSelected(row)"></b-form-checkbox>
                  </template>
                  <template v-slot:cell(modul)="row">
                    <span v-if="row.item.lehrgang">
                      {{ row.item.veranstaltung ? row.item.veranstaltung.bezeichnung : $t("global.allmodules") }}
                    </span>
                    <span v-else-if="row.item.veranstaltung">{{ row.item.veranstaltung.bezeichnung }}</span>
                  </template>
                  <template v-slot:cell(belegung)="row">
                    <span :class="{ 'text-danger font-weight-bold': ueberbucht(row.item) }">
                      {{ row.item.maxBelegungProNacht }}<span v-if="row.item.kontingent != null"> / {{ row.item.kontingent }}</span>
                    </span>
                  </template>
                </b-table>

                <infinite-loading :identifier="infiniteId" @infinite="($state) => infiniteHandler($state, 'app-api')">
                  <div slot="spinner">{{ $t("global.loadmoredata") }}</div>
                  <div slot="no-more">{{ $t("global.nofurtherdata") }}</div>
                  <div slot="no-results">{{ $t("global.nofurtherdatafound") }}</div>
                </infinite-loading>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loeschen-modal
      id="hotelkontingent-loeschen-modal"
      @confirmed="loeschen"
      :selectedIds="selectedIds"
      :multiple="true"
    />
    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import HeadMenu from "@/components/HeadMenu";
import HeadMenuFilter from "@/components/HeadMenuFilter";
import Navbar from "@/components/Navbar";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { LADE_AUSWAHLWERTE_RESSOURCEN } from "@/store/ressourcen/actions.type";

import store from "@/store";
import page from "@/mixins/Page";
import dashboard from "@/mixins/Dashboard";
import filter from "@/mixins/Filter";

export default {
  name: "Hotelkontingentliste",
  components: { Navbar, HeadMenu, HeadMenuFilter, LoeschenModal, FilterSearchResetButton },
  metaInfo() {
    return {
      titleTemplate: () => "BX: " + this.$t("global.hotelquotas"),
    };
  },
  mixins: [page, dashboard, filter],
  store,
  computed: {
    gebaeude() {
      return this.$store.state.ressourcen.gebaeude;
    },
    fields() {
      return [
        { key: "selected", label: "" },
        { key: "gebaeude.bezeichnung", sortable: true, label: this.$t("global.hotel") },
        { key: "lehrgang.bezeichnung", sortable: true, searchable: false, label: this.$t("global.educationcourse") },
        { key: "modul", label: this.$t("global.shorteventormodule") },
        { key: "belegung", label: this.$t("global.maxoccupancypernight") },
        { key: "anzahlReservationen", label: this.$t("global.roomreservations") },
        { key: "verrechnungsposition.bezeichnung", label: this.$t("global.clearingitempernight") },
      ];
    },
    queryParams() {
      return {
        gebaeude: this.setQueryParam(this.filters.gebaeude),
        filterLehrgang: this.setQueryParam(this.filters.lehrgang),
        filterVeranstaltung: this.setQueryParam(this.filters.veranstaltung),
        filterCount: this.setQueryParam(this.filters.count),
      };
    },
  },
  created() {
    this.initFilter("hotelkontingent-liste", "liste-zimmer/", true);
    if (this.gebaeude.length == 0) this.$store.dispatch(`ressourcen/${LADE_AUSWAHLWERTE_RESSOURCEN}`);
  },
  mounted() {
    this.$bus.$emit("searchWithFilter");
  },
  methods: {
    ueberbucht(kontingent) {
      return kontingent.kontingent != null && kontingent.maxBelegungProNacht > kontingent.kontingent;
    },
    details(kontingent) {
      this.$router.push({ name: "hotelkontingent", params: { id: kontingent.id, anzeige: 0 } });
    },
    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0) this.$bus.$emit("openLoeschenModal", "hotelkontingent-loeschen-modal");
    },
    loeschen() {
      AppApi.delete("zimmer/", { params: { ids: this.selectedIds.join(",") } })
        .then(() => this.resetLoading(this))
        .catch((e) => this.$notify(apiErrorToAlert(e)));
    },
  },
};
</script>

<style></style>
